// extracted by mini-css-extract-plugin
export default {"root":"TitleButton_root__xzkfz"};